import { useCallback, useEffect } from 'react';
import { useAppDispatch } from 'redux-store/hooks/useAppDispatch';

import { removeActivePostDraftId } from 'redux-store/slices/draft-slice';

export const useActivePostDraftId = () => {
  const dispatch = useAppDispatch();

  const deleteActivePostDraftId = useCallback(() => {
    dispatch(removeActivePostDraftId());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(removeActivePostDraftId());
    };
  }, []);

  return { deleteActivePostDraftId };
};
